import { FiUserRequestsListComponent } from './fi-user-requests-list.component';
import { StatesModule } from '@uirouter/angular';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiUserRequestsListState: StatesModule = {
    states: [
        {
            name: FiStateNames.User.AccessRequests,
            url: '/AccessRequests',
            component: FiUserRequestsListComponent,
            reloadOnSearch: false,
        },
    ],
};
